import React, { useState } from "react";
import {
	TextField,
	Button,
	Box,
	Checkbox,
	FormGroup,
	FormControlLabel,
} from "@mui/material";

import {
	setHasSearched,
	setSearching,
	setSearchResults,
	setSelectedItem,
} from "../../../store/slices/searchSlice.ts";
import { useAppDispatch } from "../../../store/hooks.ts";
import { SERVER_URL } from "../../../config.js";
import globalAxios from "../../../globalAxios.js";

const Search = () => {
	const dispatch = useAppDispatch();
	const [query, setQuery] = useState("");
	const [selectedTypes, setSelectedTypes] = useState<string[]>([
		"Patient",
		"Event",
		"Session",
	]);

	const handleTypeToggle = (type: string) => {
		setSelectedTypes((prev) =>
			prev.includes(type)
				? prev.filter((t) => t !== type)
				: [...prev, type]
		);
	};

	const handleSearch = async () => {
		dispatch(setSearching(true));
		dispatch(setSelectedItem(null));
		dispatch(setSearchResults([]));
		dispatch(setHasSearched(false));

		try {
			const response = await globalAxios.post(`${SERVER_URL}/search`, {
				searchTerm: query,
				types: selectedTypes, // future-proofed
			});

			dispatch(setSearchResults(response.data.results));
			dispatch(setHasSearched(true));
		} catch (err) {
			console.error("Search failed:", err);
			dispatch(setHasSearched(true));
		} finally {
			dispatch(setSearching(false));
		}
	};

	const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault(); // prevent page reload
		await handleSearch();
	};

	return (
		<Box sx={{ maxWidth: 500, mx: "auto", mt: 2 }}>
			<form onSubmit={handleSubmit}>
				<Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
					<TextField
						size="small"
						label="Search"
						variant="outlined"
						fullWidth
						value={query}
						onChange={(e) => setQuery(e.target.value)}
					/>
					<Button type="submit" disableElevation variant="contained">
						Search
					</Button>
					<FormGroup>
						<FormControlLabel
							control={
								<Checkbox
									checked={selectedTypes.includes("Patient")}
									onChange={() => handleTypeToggle("Patient")}
								/>
							}
							label="Patient"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={selectedTypes.includes("Event")}
									onChange={() => handleTypeToggle("Event")}
								/>
							}
							label="Event"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={selectedTypes.includes("Session")}
									onChange={() => handleTypeToggle("Session")}
								/>
							}
							label="Session"
						/>
					</FormGroup>
				</Box>
			</form>
		</Box>
	);
};

export default Search;
